// shared-lib/group-customization/unplaced.js
//
// What a builder CONSIDERED for a group and could not place — a mirror that
// would overlap the window, sconces the wall beside the mirror cannot take.
// Recorded on the group's anchor as `groupCustomization.unplaced`, so "no
// mirror" is explained instead of silent (layout-relationships §3.4).
//
//   unplaced: [{ type, reason, ref? }]
//
// One entry per TYPE is the contract: a new decision about mirrors replaces
// the old mirror entry and leaves the sconce entry alone.

const { pickAnchor } = require('./anchorTypes');

function unplacedOf(anchor) {
  const u = anchor?.groupCustomization?.unplaced;
  return Array.isArray(u) ? u : [];
}

/** The member that carries the group's record: THE anchor (#1533 — an
 *  array-order "any carrier" preference could stamp `unplaced` on a stray
 *  sink while the editor read the cabinet's; `pickAnchor` itself already
 *  falls back to a carrier when no preferred type is present). */
function anchorOf(objects, groupId) {
  const members = (objects || []).filter((o) => o?.fixtureGroupId === groupId);
  if (!members.length) return null;
  return pickAnchor(members);
}

/**
 * Pure. Returns a new objects array with the group's `unplaced` record
 * updated: entries whose `type` is in `entries` or `clearTypes` are
 * dropped, then `entries` are appended. Identity when nothing changes.
 *
 * @param {Object[]} objects
 * @param {string} groupId
 * @param {{type:string, reason:string, ref?:Object}[]} entries
 * @param {{ clearTypes?: string[] }} [opts] — types this run decided about
 *   and DID place, whose stale entries must go
 */
function stampUnplaced(objects, groupId, entries, opts = {}) {
  const anchor = groupId && anchorOf(objects, groupId);
  if (!anchor) return objects;
  const fresh = (entries || []).filter((e) => e?.type && e?.reason);
  const drop = new Set([
    ...fresh.map((e) => e.type),
    ...(opts.clearTypes || []),
  ]);
  const cur = unplacedOf(anchor);
  const kept = cur.filter((e) => !drop.has(e?.type));
  if (kept.length === cur.length && fresh.length === 0) return objects;
  const next = [...kept, ...fresh];
  const cz = { ...(anchor.groupCustomization || {}) };
  if (next.length) cz.unplaced = next;
  else delete cz.unplaced;
  const stamped = { ...anchor, groupCustomization: cz };
  return objects.map((o) => (o === anchor ? stamped : o));
}

module.exports = { stampUnplaced, unplacedOf };
